import styled from "@emotion/native"
import CloseCircleIcon from "../assets/close_circle.svg"
import { Text, TextProps } from "./Typography"
import { Pressable } from "react-native"

type FilterProps = {
  labelText: string
  onPress: () => void
  active: boolean
  disabled?: boolean
  resetFilter: () => void
}

export function Filter(props: FilterProps) {
  const { active, labelText, onPress, disabled, resetFilter } = props
  let labelColor: TextProps["color"] = "primary"
  if (active) {
    labelColor = "quaternary"
  }
  if (disabled) {
    labelColor = "gray500"
  }

  return (
    <FilterContainer active={active} disabled={disabled} onPress={onPress}>
      <Text
        fontSize={18}
        lineHeight={22}
        color={labelColor}
        disabled={disabled}
        fontFamily="IBMPlexSans-SemiBold"
      >
        {labelText}
      </Text>
      {active && (
        <Pressable onPress={resetFilter}>
          <CloseCircleIcon />
        </Pressable>
      )}
    </FilterContainer>
  )
}

const FilterContainer = styled.Pressable<{ active: boolean; disabled?: boolean }>`
  background-color: ${({ theme, active }) =>
    active
      ? theme.button.filter.active.backgroundColor
      : theme.button.filter.inactive.backgroundColor};
  justify-content: center;
  padding: 9.5px 14px 9.5px 14px;
  max-height: 44px;
  border-radius: 100px;
  border-color: ${({ theme, active }) =>
    active ? theme.button.filter.active.borderColor : theme.button.filter.inactive.borderColor};
  border-width: 1px;
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  flex-direction: row;
  align-items: center;
  gap: 12px;
`
